import React, { useCallback, useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { Menu } from '../Icons';
import type { DropDownMenuProps } from './types';
import './dropDownMenu.scss';

// eslint-disable-next-line @typescript-eslint/no-empty-function
const noop = (): void => {};

export const DropDownMenu: React.FC<DropDownMenuProps> = ({
  className,
  children,
  defaultOpen,
  triggerElement = <Menu onClick={noop} />,
  ...props
}) => {
  const [open, setOpen] = useState(defaultOpen);
  const ref = useRef<HTMLDivElement>(null);
  const toggleOpen = useCallback(() => setOpen(o => !o), []);
  const closeMenu = useCallback((e: MouseEvent) => {
    if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
  }, []);
  useEffect(() => {
    document.addEventListener('mousedown', closeMenu);
    return () => document.removeEventListener('mousedown', closeMenu);
  }, [closeMenu]);
  return (
    <div role="none" ref={ref} className={cn('dropdown-default', { open }, className)} onClick={toggleOpen} {...props}>
      {triggerElement}
      <ul>{children}</ul>
    </div>
  );
};
